import { store } from '../store';
import { api } from './config/axios';

const getConfig = () => {
  const { token } = store.getState().auth;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

/**
 * Dispatches a push notification, email, SMS, or multi-channel broadcast.
 * @param {object} payload
 */
export const sendNotificationBroadcast = (payload) => {
  return api.post('/api/v1/admin/notifications/broadcast', payload, getConfig());
};

/**
 * Fetches recent notification broadcasts and delivery logs.
 */
export const getNotificationHistory = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api.get(`/api/v1/admin/notifications/history${query ? `?${query}` : ''}`, {}, getConfig());
};

/**
 * Fetches complete details of a specific broadcast dispatch.
 * @param {number|string} id
 */
export const getBroadcastDetails = (id) => {
  return api.get(`/api/v1/admin/notifications/history/${id}`, {}, getConfig());
};

/**
 * Fetches SMS providers configuration (active provider, credentials, registered sender IDs).
 */
export const getSmsProvidersConfig = () => {
  return api.get('/api/v1/admin/notifications/sms/config', {}, getConfig());
};

/**
 * Updates SMS provider settings, API keys, default sender ID, or active provider.
 * @param {object} payload
 */
export const updateSmsProvidersConfig = (payload) => {
  return api.put('/api/v1/admin/notifications/sms/config', payload, getConfig());
};

/**
 * Sends a test SMS or WhatsApp to verify provider credentials and connectivity.
 * @param {object} payload - { providerSlug, recipientPhone, senderId, message, channel }
 */
export const testSmsConnection = (payload) => {
  return api.post('/api/v1/admin/notifications/sms/test', payload, getConfig());
};

/**
 * Queries live credit balance for a specified SMS provider.
 * @param {string} providerSlug
 */
export const checkSmsBalance = (providerSlug) => {
  return api.get(`/api/v1/admin/notifications/sms/balance/${providerSlug}`, {}, getConfig());
};

/**
 * Queries live credit balances for all configured providers (HollaTags & KudiSMS).
 * @param {boolean} refresh
 */
export const checkAllBalances = (refresh = false) => {
  return api.get(`/api/v1/admin/notifications/providers/balance${refresh ? '?refresh=true' : ''}`, {}, getConfig());
};
